export default __webpack_public_path__ + "static/media/architecture.8c418497.png";